// src/redux/medicosSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { db } from '../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';

const initialState = {
  medicos: [],
  status: 'idle',
  error: null,
};

export const createCurriculum = createAsyncThunk(
  'medicos/createCurriculum',
  async (medicoData) => {
    const docRef = await addDoc(collection(db, 'medicos'), medicoData);
    return { id: docRef.id, ...medicoData };
  }
);

const medicosSlice = createSlice({
  name: 'medicos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCurriculum.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createCurriculum.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.medicos.push(action.payload);
      })
      .addCase(createCurriculum.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default medicosSlice.reducer;
